export const selectUser = (state) => state.user;
export const selectUserPermissions = (state) => selectUser(state).permissions;
export const selectUserLender = (state) => selectUser(state).lender;
